import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from "./AddressInfo.module.scss";
export const AddressStreetInfoWithRegion = ({ streetNumber, streetName, streetAdditional, regionName, city, postcode, countryName, isReversed, hidePostCode = false, }) => {
    const streetInfo = isReversed
        ? `${streetNumber} ${streetName} ${streetAdditional}`
        : `${streetName} ${streetNumber} ${streetAdditional}`;
    const cityWithPostcode = hidePostCode || !postcode ? city : `${city} ${postcode}`;
    const addressInfo = [regionName, cityWithPostcode, countryName].filter(Boolean).join(", ");
    return (_jsxs("div", { className: styles.regionAddressInfo, children: [_jsx("p", { children: streetInfo }), _jsx("p", { children: addressInfo })] }));
};
//# sourceMappingURL=AddressStreetInfoWithRegion.js.map